import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#fa8c16', 'Onaylandı': '#52c41a', 'Reddedildi': '#f5222d' };
const DURUM_RGB: Record<string, string> = { 'Bekliyor': '250,140,22', 'Onaylandı': '82,196,26', 'Reddedildi': '245,34,45' };

@Component({
  selector: 'izin-kaydi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--izin" [style.--accent]="durumRenk()" [style.--accent-rgb]="durumRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">İZİN KAYDI</div>
        <div class="iz-ust">
          <div class="iz-tur gc-baslik-ana">{{ p()?.izinTuru || 'Yıllık' }}</div>
          <div class="iz-durum-badge">{{ p()?.durum || 'Bekliyor' }}</div>
        </div>
        <div class="iz-gun">{{ p()?.gun || 1 }} <span class="iz-gun-label">GÜN</span></div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 65 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #059669; --accent-rgb: 5,150,105; }
    .iz-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .iz-tur { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); }
    .iz-durum-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); }
    .iz-gun { font-size: 22px; font-weight: 900; color: #34d399; font-variant-numeric: tabular-nums; text-shadow: 0 0 12px rgba(52,211,153,.3); }
    .iz-gun-label { font-size: 10px; font-weight: 500; color: var(--py-metin-ikincil, #64748b); margin-left: 4px; }
  `],
})
export class IzinKaydiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  durumRenk = computed(() => DURUM_RENK[this.p()?.durum] || '#059669');
  durumRgb = computed(() => DURUM_RGB[this.p()?.durum] || '5,150,105');
}
